/**
 * Cart Custom Fee Base Processor - 购物车定制费基础处理器
 * 所有工艺处理器的基类
 */

// 工艺处理器基类
class CraftProcessor {
  constructor(config) {
    this.config = config;
  }
  
  getVariantIdByQuantity(quantity) {
    const range = this.config.ranges.find(r => quantity >= r.min && quantity <= r.max);
    return range ? range.variantId : null;
  }
  
  getPriceRangeByQuantity(quantity) {
    const range = this.config.ranges.find(r => quantity >= r.min && quantity <= r.max);
    return range || null;
  }
  
  needsSetupFee(quantity) {
    return quantity >= 1 && quantity <= 11; // Setup Fee 只有1-11个时需要
  }
  
  createCustomFeeItems(quantity, customSidesData, draftOrderId) {
    const requiredVariantId = this.getVariantIdByQuantity(quantity);
    if (!requiredVariantId) return [];

    const items = [];
    
    // 处理customSidesData，支持数量(旧版)或实际定制面数组(新版)
    let actualCustomSides = [];
    if (Array.isArray(customSidesData)) {
      // 新版：直接使用用户选择的定制面数组
      actualCustomSides = customSidesData;
    } else if (typeof customSidesData === 'number') {
      // 旧版兼容：根据数量生成默认侧面名称
      const defaultSideNames = ['front', 'back', 'left', 'right'];
      for (let i = 0; i < customSidesData; i++) {
        actualCustomSides.push(defaultSideNames[i] || `side${i + 1}`);
      }
    }

    // 为每个实际选择的定制面创建费用项
    actualCustomSides.forEach((customSide, index) => {
      items.push({
        type: 'custom_fee',
        variantId: requiredVariantId,
        quantity: quantity,
        properties: {
          '_draft_order': draftOrderId,
          '_custom_fee_type': this.config.processType,
          '_custom_side': customSide,
          '_custom_description': `${this.config.productTitle} - ${this.getCustomSideDisplayName(customSide)} (${quantity} items)`
        },
        key: `custom_${draftOrderId}_${customSide}`
      });
    });

    return items;
  }
  
  /**
   * 获取定制面显示名称
   */
  getCustomSideDisplayName(customSide) {
    const sideNames = {
      'front': 'Front',
      'back': 'Back', 
      'left': 'Left',
      'right': 'Right',
      'top': 'Top',
      'bottom': 'Bottom'
    };
    return sideNames[customSide] || customSide;
  }
  
  createSetupFeeItem(quantity, draftOrderId) {
    if (!this.needsSetupFee(quantity)) return null;
    
    return {
      type: 'setup_fee',
      variantId: 46024060829849, // Digitizing Fee 变体ID
      quantity: 1,
      properties: {
        '_draft_order': draftOrderId,
        '_setup_fee': 'true'
      },
      key: `setup_${draftOrderId}`
    };
  }
  
  isCustomFeeProduct(item) {
    // 检查 handle
    if (item.handle === this.config.productHandle) return true;
    
    // 检查商品标题
    if (item.product_title === this.config.productTitle) return true;
    
    // 检查属性
    if (item.properties && item.properties._custom_fee_type === this.config.processType) return true;
    
    return false;
  }
}

// 将基类暴露到全局作用域
window.CraftProcessor = CraftProcessor;